import { useState, useRef, useEffect, useCallback } from "react";
import { calcInsert } from "../components/DateInputControl/utils/calcInsert.js";
const validDate = (value, mask) => !(!value || value.length !== mask.length || /[ymd]/i.test(value)), useDateInputMask = ({
  mask: initialMask,
  value: externalValue = initialMask,
  validate,
  onChange
}) => {
  const [inputElement, setInputElement] = useState(
    null
  ), [value, setValue] = useState(externalValue), selection = useRef([]);
  useEffect(() => {
    externalValue !== value && setValue(externalValue);
  }, [externalValue]);
  const externalRefs = useRef({ validate, onChange });
  externalRefs.current.validate = validate, externalRefs.current.onChange = onChange;
  const handleSetSelection = useCallback(() => {
    selection.current.push({
      selectionStart: inputElement == null ? void 0 : inputElement.selectionStart,
      selectionEnd: inputElement == null ? void 0 : inputElement.selectionEnd
    }), selection.current = selection.current.slice(-3);
  }, [inputElement == null ? void 0 : inputElement.selectionEnd, inputElement == null ? void 0 : inputElement.selectionStart]), onChangeCapture = useCallback(
    (e) => {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      const params = {
        maskedValueAfter: e.target.value,
        maskedValueBefore: value,
        initialMask,
        cursorPositionAfter: (_a = e.target) == null ? void 0 : _a.selectionStart,
        selectionStartBefore: ((_b = selection.current.at(-1)) == null ? void 0 : _b.selectionStart) ?? 0,
        selectionEndBefore: ((_d = (_c = selection.current) == null ? void 0 : _c.at(-1)) == null ? void 0 : _d.selectionEnd) ?? 0
      }, cursorPositionAndValue = calcInsert(params);
      if (!cursorPositionAndValue)
        return;
      let newValue = cursorPositionAndValue.maskedValue, newPosition = cursorPositionAndValue.cursorPosition;
      if (externalRefs.current.validate) {
        const { value: value2, year, day, month } = externalRefs.current.validate(
          cursorPositionAndValue.maskedValue
        );
        if (newValue = value2, typeof day < "u" && typeof month < "u" && !day && !month) {
          const iD = initialMask.indexOf("d"), iM = initialMask.indexOf("m");
          newPosition = Math.min(iD, iM);
        } else typeof day < "u" && !day ? newPosition = initialMask.indexOf("d") : typeof month < "u" && !month ? newPosition = initialMask.indexOf("m") : typeof year < "u" && !year && (newPosition = initialMask.indexOf("y"));
      }
      setValue(newValue), validDate(newValue, initialMask) ? (_f = (_e = externalRefs.current).onChange) == null || _f.call(_e, newValue) : newValue === initialMask && newValue !== value && ((_h = (_g = externalRefs.current).onChange) == null || _h.call(_g, "")), window.requestAnimationFrame(() => {
        inputElement == null || inputElement.setSelectionRange(newPosition, newPosition);
      });
    },
    [initialMask, inputElement, value]
  );
  return {
    ref: (el) => {
      setInputElement(el);
    },
    onChangeCapture,
    onKeyUp: handleSetSelection,
    onKeyDown: handleSetSelection,
    clearDate: () => {
      setValue(initialMask), onChange == null || onChange("");
    },
    value
  };
};
export {
  useDateInputMask
};
//# sourceMappingURL=useDateInputMask.js.map
